module.exports = __webpack_public_path__ + "static/img/searchShort.cfdd550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/searchShort.png
// module id = eJoQ
// module chunks = 1